module.exports = __webpack_public_path__ + "static/media/contact.b598c863.gif";